import { Timestamp } from "firebase/firestore";
import { z } from "zod";

export const SmileSimulationTypeSchema = z.enum(["photo", "video"]);
export const SmileSimulationChartNumberSchema = z
  .string()
  .trim()
  .min(1)
  .optional();
export const SmileSimulationPatientNameSchema = z
  .string()
  .trim()
  .min(1)
  .optional();
export const SmileSimulationAspectRatioSchema = z.string().trim().min(1);
export const SmileSimulationProviderSchema = z
  .enum(["google", "openai"])
  .optional();
export const SmileSimulationImageModelSchema = z
  .string()
  .trim()
  .min(1)
  .optional();
export const SmileSimulationOpenAiQualitySchema = z
  .enum(["low", "medium", "high"])
  .optional();
export const SmileSimulationPromptVersionSchema = z
  .enum(["aesthetic-freeform", "vertical-lock"])
  .optional();
export const SmileSimulationImagePathSchema = z.string().trim().min(1);
export const SmileSimulationVideoPathSchema = z
  .string()
  .trim()
  .min(1)
  .nullish();

export const FirestoreTimestampSchema = z.custom<Timestamp>(
  (value): value is Timestamp => value instanceof Timestamp,
);

export const SmileSimulationDataSchema = z.object({
  type: SmileSimulationTypeSchema,
  chartNumber: SmileSimulationChartNumberSchema,
  patientName: SmileSimulationPatientNameSchema,
  aspectRatio: SmileSimulationAspectRatioSchema.default("3:4"),
  provider: SmileSimulationProviderSchema,
  imageModel: SmileSimulationImageModelSchema,
  openAiQuality: SmileSimulationOpenAiQualitySchema,
  promptVersion: SmileSimulationPromptVersionSchema,
  baseImagePath: SmileSimulationImagePathSchema,
  generatedImagePath: SmileSimulationImagePathSchema,
  generatedVideoPath: SmileSimulationVideoPathSchema,
});

export const SmileSimulationUpdateDataSchema = z.object({
  type: SmileSimulationTypeSchema.optional(),
  chartNumber: SmileSimulationChartNumberSchema.optional(),
  patientName: SmileSimulationPatientNameSchema.optional(),
  aspectRatio: SmileSimulationAspectRatioSchema.optional(),
  provider: SmileSimulationProviderSchema,
  imageModel: SmileSimulationImageModelSchema,
  openAiQuality: SmileSimulationOpenAiQualitySchema,
  promptVersion: SmileSimulationPromptVersionSchema,
  baseImagePath: SmileSimulationImagePathSchema.optional(),
  generatedImagePath: SmileSimulationImagePathSchema.optional(),
  generatedVideoPath: SmileSimulationVideoPathSchema,
});

export const SmileSimulationSchema = SmileSimulationDataSchema.extend({
  clinicId: z.string().trim().min(1),
  createdAt: FirestoreTimestampSchema,
  updatedAt: FirestoreTimestampSchema,
});

export type SmileSimulationData = z.infer<typeof SmileSimulationDataSchema>;
export type SmileSimulation = z.infer<typeof SmileSimulationSchema>;
